import axios from "axios";
import { CallAPI } from "apiManager/ApiCall";
import { basicURL } from "apiManager/APIConfig";
import { store } from "../store";

function resolveAuthHeader() {
  const access_token = store.getState().auth?.access_token;
  if (!access_token) return "";
  return access_token.startsWith("Bearer ")
    ? access_token
    : `Bearer ${access_token}`;
}

export const listStudyPlansCall = () =>
  CallAPI({ url: "study-plans", method: "GET" });

export const GetStudyPlanUsageCall = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set("page", String(params.page));
  if (params.limit) qs.set("limit", String(params.limit));
  if (params.search) qs.set("search", params.search);
  const query = qs.toString();
  return CallAPI({ url: `study-plans/admin/usage${query ? `?${query}` : ""}`, method: "GET" });
};

/** Admin-only: full read-only study plan (materials + lesson content). */
export const GetAdminStudyPlanCall = (planId) => {
  if (!planId) return Promise.resolve({ status: 400, message: "planId required" });
  return CallAPI({ url: `study-plans/admin/${planId}`, method: "GET" });
};

export const getStudyPlanCall = (planId) =>
  CallAPI({ url: `study-plans/${planId}`, method: "GET" });

export const createStudyPlanCall = (body) =>
  CallAPI({ url: "study-plans", method: "POST", body });

/**
 * POST study-plans/:id/materials — multipart upload (PDF / PPT / Word / image / audio).
 * Mirrors mobile uploadStudyPlanMaterialCall.
 */
export const uploadStudyPlanMaterialCall = async (planId, file, onProgress) => {
  if (!planId || !file) return { status: 400, message: "No file provided." };
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${basicURL}study-plans/${planId}/materials`,
      formData,
      {
        headers: { Authorization: resolveAuthHeader() },
        onUploadProgress: (event) => {
          if (event?.total && typeof onProgress === "function") {
            onProgress(event.loaded / event.total);
          }
        },
        timeout: 3 * 60 * 1000,
      }
    );
    return response?.data;
  } catch (err) {
    if (err?.response?.data) return err.response.data;
    return {
      status: err?.response?.status || 0,
      message: err?.message || "Network error during upload.",
    };
  }
};

/** POST study-plans/:id/extract-topics — derive topics from uploaded materials. */
export const extractStudyTopicsCall = async (planId) => {
  if (!planId) return { status: 400, message: "Plan id required." };
  try {
    const response = await axios.post(
      `${basicURL}study-plans/${planId}/extract-topics`,
      {},
      {
        headers: {
          Authorization: resolveAuthHeader(),
          "Content-Type": "application/json",
        },
        timeout: 4 * 60 * 1000,
      }
    );
    return response?.data;
  } catch (err) {
    if (err?.response?.data) return err.response.data;
    return {
      status: err?.response?.status || 0,
      message: err?.message || "Could not extract topics from your files.",
    };
  }
};

export const deleteStudyPlanCall = (planId) =>
  CallAPI({ url: `study-plans/${planId}`, method: "DELETE" });

export const generateStudyLessonCall = (planId, topicId) =>
  CallAPI({
    url: `study-plans/${planId}/topics/${topicId}/lessons`,
    method: "POST",
    body: {},
  });

export const saveLessonProgressCall = (planId, lessonId, body) =>
  CallAPI({
    url: `study-plans/${planId}/lessons/${lessonId}/progress`,
    method: "PUT",
    body,
  });

export const listStudyPodcastsCall = () =>
  CallAPI({ url: "study-plans/podcasts", method: "GET" });

export const requestLessonPodcastCall = (planId, lessonId) =>
  CallAPI({
    url: `study-plans/${planId}/lessons/${lessonId}/podcast`,
    method: "POST",
    body: {},
  });
